const memberTeamsSelector = (
    state: sage.state.IRedux
): sage.model.ITeam[] | null => {
    return state.teams.memberTeams;
};

export default memberTeamsSelector;
